module.exports = __webpack_public_path__ + "img/27.7fcc4d50.jpg";